import Naluri from '~/common/api/naluri';
import {
  NEW_PROFILE_GET_HEALTH_DATA_BEGIN,
  NEW_PROFILE_GET_HEALTH_DATA_SUCCESS,
  NEW_PROFILE_GET_HEALTH_DATA_FAILURE,
  NEW_PROFILE_GET_HEALTH_DATA_DISMISS_ERROR,
} from './constants';

export function getHealthData(userID) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: NEW_PROFILE_GET_HEALTH_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = Naluri.get(`/api/expert/profile/health_data/${userID}`);
      doRequest.then(
        res => {
          dispatch({
            type: NEW_PROFILE_GET_HEALTH_DATA_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: NEW_PROFILE_GET_HEALTH_DATA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetHealthDataError() {
  return {
    type: NEW_PROFILE_GET_HEALTH_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case NEW_PROFILE_GET_HEALTH_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getHealthDataPending: true,
        getHealthDataError: null,
      };

    case NEW_PROFILE_GET_HEALTH_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        getHealthDataPending: false,
        getHealthDataError: null,
        healthData: action.data,
      };

    case NEW_PROFILE_GET_HEALTH_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        getHealthDataPending: false,
        getHealthDataError: action.data.error,
      };

    case NEW_PROFILE_GET_HEALTH_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getHealthDataError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/new-profile/redux/getHealthData.js